import { Box, Flex, Text } from "@chakra-ui/react";

function CustomCircularProgress({
    value = "",
    total = 100,
    size = "100px",
    strokeWidth = "5px",
    ringColor = "#F0F0F0",
    color = "#002B49",
    textColor = "#000",
    fontSize = "md",
    fontWeight = 600,
    displayText = "",
}) {
    const radius = 50 - parseFloat(strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const progressOffset = circumference - (value / total) * circumference;

    return (
        <Box
            width={size}
            height={size}
            borderRadius="full"
            position="relative"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            overflow="hidden"
        >
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 100 100"
                style={{
                    transform: "rotate(-90deg)",
                }}
            >
                <circle
                    cx="50"
                    cy="50"
                    r={radius}
                    fill="transparent"
                    stroke={ringColor}
                    strokeWidth={strokeWidth}
                />
                <circle
                    cx="50"
                    cy="50"
                    r={radius}
                    fill="transparent"
                    stroke={color}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={progressOffset}
                    strokeLinecap="round"
                    style={{
                        transition: "stroke-dashoffset 0.35s ease-out",
                    }}
                />
            </svg>

            <Flex
                position="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                align="center"
                justify="center"
            >
                <Text fontWeight={fontWeight} fontSize={fontSize} color={textColor}>
                    {displayText || `${value} de ${total}`}
                </Text>
            </Flex>
        </Box>
    );
}

export default CustomCircularProgress;
